"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableSort = void 0;
const react_1 = require("react");
const sort_1 = require("@groupby/enrich-sdk/sort");
const useTableSort = () => {
    const [sortParams, setSortParams] = (0, react_1.useState)([{ propertyName: 'id', direction: sort_1.SortDirection.Ascending }]);
    const handleSort = (0, react_1.useCallback)((propertyName) => {
        const isDescending = sortParams[0].propertyName === propertyName
            && sortParams[0].direction === sort_1.SortDirection.Ascending;
        const direction = isDescending ? sort_1.SortDirection.Descending : sort_1.SortDirection.Ascending;
        setSortParams([{ propertyName, direction }]);
    }, [sortParams]);
    return { sortParams, handleSort };
};
exports.useTableSort = useTableSort;
exports.default = exports.useTableSort;
